import { OpmFirstLastWaterfallDictionaryDto } from '@app/shared/models/contracts/opm-calculation-results-dto';
import styles from '@app/modules/projects/outputs/opm-summary-waterfall/opm-summary-waterfall-erf.module.scss';
import CellValue from '@app/shared/components/cell-value/CellValue';
import classNames from 'classnames';
import { TransactionType } from '@app/shared/models/contracts/enums/shared-enums';
import {
  getSimulationKeys,
  getTransactionValues,
  simulationSectionsDefinition,
} from '../../helper/FirstLastHelpers';
import { amountWithDecimalRules } from '@app/shared/components/cell-value/CellValueConfigurations';

interface InstrumentDiscountFactorRowProps {
  opmWaterfall: OpmFirstLastWaterfallDictionaryDto;
  selectedYear: string;
  selectedInstrument: string;
  transactionType: TransactionType;
}

const InstrumentDiscountFactorRow: React.FC<InstrumentDiscountFactorRowProps> = ({
  opmWaterfall,
  selectedYear,
  selectedInstrument,
  transactionType,
}: InstrumentDiscountFactorRowProps) => {
  const simulationKeys = getSimulationKeys(opmWaterfall, selectedYear);

  const transactionValues = getTransactionValues(
    opmWaterfall,
    selectedYear,
    selectedInstrument,
    transactionType,
    'discountFactor'
  );

  const allTransactions = Object.keys(transactionValues);
  if (allTransactions.length === 0) {
    return null;
  }

  return (
    <>
      {allTransactions.map((transactionName, rowIdx) => (
        <tr key={`${transactionType}-discount-row-${rowIdx}`}>
          <td
            className={classNames(styles['border-right'])}
            data-testid={`${transactionType}-discount-narrative-title-${rowIdx}`}>
            {transactionName}
          </td>
          {simulationSectionsDefinition.map((section, outerIdx) =>
            Object.keys(opmWaterfall[selectedYear][section]).map((simKey, innerIdx) => (
              <td
                key={`${section}-${simKey}`}
                className={classNames({
                  [styles['border-right']]:
                    outerIdx === 0 && innerIdx + 1 === simulationKeys[0].length,
                })}
                data-testid={`${transactionType}-discount-simulation-${section}-${simKey}-${rowIdx}`}>
                <CellValue
                  value={transactionValues[transactionName][section]?.[simKey] ?? null}
                  {...amountWithDecimalRules}
                />
              </td>
            ))
          )}
        </tr>
      ))}
    </>
  );
};

export default InstrumentDiscountFactorRow;
